const getRequired = variables =>
  variables.filter(item => item.required).map(({ name }) => name);

export default getRequired;
